<template>
  <div>
    <div v-for="(comunicado, index) in comunicadosFiltrados" :key="comunicado.id">
      <div>
        <v-dialog
          v-model="comunicado.dialogComunicado"
          :persistent="comunicado.persistente"
          max-width="800"
        >
          <v-card>
            <v-card-text v-if="!comunicado.multiComunicado">
              <v-card-title class="justify-center" v-if="comunicado.titulo">
                <h3 class="mt-0" style="color: #01579B;"><strong>{{ comunicado.titulo }}</strong></h3>
              </v-card-title>
              <hr class="ma-1" color="#34699a" v-if="comunicado.titulo">
              <p style="text-align: justify;" v-html="comunicado.mensaje"></p>
            </v-card-text>
            <v-card-text v-else>
              <v-card-title class="justify-center" v-if="comunicado.titulo">
                <h3 class="mt-0" style="color: #01579B;"><strong>{{ comunicado.titulo }}</strong></h3>
              </v-card-title>
              <hr class="ma-1" color="#34699a" v-if="comunicado.titulo">
              <div v-for="(detalle, detalleIndex) in comunicado.mensajes" :key="detalleIndex">
                <v-card-title class="justify-center" v-if="detalle.titulo">
                  <h3 class="mt-0" style="color: #01579B;"><strong>{{ detalle.titulo }}</strong></h3>
                </v-card-title>
                <hr class="ma-1" color="#34699a" v-if="detalle.titulo">
                <p style="text-align: justify;" v-html="detalle.mensaje"></p>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="cerrarDialogo(comunicado)">CERRAR</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import comunicadosData from './comunicado.mensajes.js';

export default {
  name: 'Comunicado',
  data () {
    return {
      comunicados: comunicadosData,
      comunicadosFiltrados: [],
      ambienteDigital: process.env.AMBIENTE_DIGITAL
    };
  },
  computed: {
    filtrados () {
      return this.comunicados
        .filter(comunicado =>
          comunicado.ambiente === null ||
          comunicado.ambiente === Number(this.ambienteDigital)
        )
        .sort((a, b) => b.orden - a.orden);
    }
  },
  mounted () {
    this.comunicadosFiltrados = this.filtrados;
    // this.abrirDialogosEnOrden();
  },
  methods: {
    abrirDialogosEnOrden () {
      this.comunicadosFiltrados.forEach((comunicado, index) => {
        setTimeout(() => {
          this.$set(this.comunicadosFiltrados, index, comunicado);
          comunicado.dialogComunicado = true;
        }, index * 100);
      });
    },
    cerrarDialogo (comunicado) {
      comunicado.dialogComunicado = false;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/portal/globalComunicado.vue